import { Text, Select, Button } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { crearReservacionExterna } from '../../services/crearReservacion';
import createBooking from '../../services/createBooking';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
} from '@chakra-ui/react';
import { verificarNoches } from '../../services/verificarNoches';
import { useTranslation } from 'react-i18next';

const ConfirmacionExterno = ({
  room,
  date,
  data,
  id,
  noches,
  offer,
  enabled,
  setBookingData,
  user,
  setDisabled,
}) => {

  const { t } = useTranslation();

  const [numeroPersonas, setNumeroPersonas] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({ error: false, msg: '' });
  const [nombreExterno, setNombreExterno] = useState('');
  const [correo, setCorreo] = useState('');
  const [token, setToken] = useState('');

  const occupancy = [];
  for (let i = 1; i <= room.max_occupancy; i++) {
    occupancy.push(i);
  }

  const onChange = (e) => {
    if (e.target.value) {
      setNumeroPersonas(e.target.value);
    } else {
      setNumeroPersonas(null);
    }
  };

  const handleBooking = async () => {
    if (!numeroPersonas) return;
    setIsLoading(true);
    setDisabled(true);
    try {
      const {
        data: { nochesDisponibles },
      } = await verificarNoches(id, noches, `${data["date_from"]}T00:00:00.000Z`, `${data["date_to"]}T00:00:00.000Z`);

      if (!nochesDisponibles) {
        setError({ error: true, msg: t('NO_AVAILABLE_NIGHTS') });
        setIsLoading(false);
        return;
      }

      const { data: booking, status } = await createBooking(data);

      if (status !== 200) {
        onOpen();
        setError({
          error: true,
          msg: t('BOOKING_CREATION_FAILED'),
        });
        return;
      }

      const {
        data: { reservacion },
        status: reservacionStatus,
      } = await crearReservacionExterna({
        fechaLlegada: booking.date_arrival + 'T00:00:00.000Z',
        fechaSalida: booking.date_departure + 'T00:00:00.000Z',
        tipoReservacion: 'EXTERNO',
        nombreQuienReserva: nombreExterno,
        nombreTitular: `${user.nombre} ${user.apellidos}`,
        tipoCabana: room.name,
        titularId: id,
        adminId: null,
        token: booking.token,
        numeroPersonas,
        noches,
        precioTotal: offer.total_price,
        descuento: null,
      });

      if (reservacionStatus !== 200) {
        onOpen();
        setError({
          error: true,
          msg: t('DATABASE_CREATION_FAILED'),
        });
        return;
      }
      setToken(reservacion.token);
      onOpen();
    } catch (error) {
      //console.log(error);
      onOpen();
      setError({
        error: true,
        msg: t('NETWORK_ERROR'),
      });
    }
  };

  useEffect(() => {
    setBookingData({
      ...data,
      customer: { ...data.customer, email: correo, first_name: nombreExterno },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correo, nombreExterno]);

  if (!enabled) return <div />;

  return (
    <div className="w-50 px-5 py-3">
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {!error.error ? t('SUCCESSFUL_BOOKING') : t('BOOKING_ERROR')}
          </ModalHeader>
          <ModalBody>
            {error.error ? (
              <div className="py-3">
                <Text>{t('ERROR_OCCURRED')} {error.msg}</Text>
                <Button
                  onClick={() => {
                    window.location.reload();
                  }}
                  me="3"
                  colorScheme="blue"
                >
                  {t('GO_TO_CALENDAR')}
                </Button>
              </div>
            ) : (
              <div className="py-1">
                <Text>
                  {t('CONFIRMATION_SENT')}
                </Text>
                <Text my="5">
                  {t('RESERVATION_TOKEN')}{' '}
                  <input
                    className="p-2 mt-2 rounded text-white d-block"
                    style={{ backgroundColor: '#3b3b3b' }}
                    readOnly
                    value={token}
                  />
                </Text>
                <Button
                  colorScheme="blue"
                  my="7"
                  onClick={() => window.location.reload()}
                >
                  {t('GO_BACK_TO_RESERVATIONS')}
                </Button>
              </div>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
      <Text
        as="b"
        fontSize={'xl'}
      >
        {t('CONFIRM')}
      </Text>
      <Text>
        {t('AGREE_RESERVATION')}{' '}
        <strong>{room.name}</strong> {t('FOR_DATES')}
      </Text>
      <Text as="b">{t('FROM_DATE')} </Text>
      <Text>{date.startStr}</Text>
      <Text as="b">{t('TO_DATE')}: </Text>
      <Text>{date.endStr}</Text>
      <div>
        {t('UNDER_NAME')}
        <input
          className="form-control w-75"
          required
          value={nombreExterno}
          onChange={(e) => setNombreExterno(e.target.value)}
          disabled={isLoading}
        />
      </div>
      <div>
        {t('EMAIL')}
        <input
          className="form-control w-75"
          required
          value={correo}
          onChange={(e) => setCorreo(e.target.value)}
          disabled={isLoading}
        />
      </div>
      <div className="my-2 w-50">
        <Select
          placeholder={t('NUMBER_OF_PEOPLE')}
          onChange={(e) => onChange(e)}
          isDisabled={isLoading}
        >
          {occupancy.map((n) => (
            <option
              key={n}
              value={n}
            >
              {n}
            </option>
          ))}
        </Select>
      </div>
      <div className="d-flex justify-content-end">
        <Button
          colorScheme={'orange'}
          mt={'4'}
          p="6"
          isDisabled={!nombreExterno || !numeroPersonas || isLoading}
          onClick={handleBooking}
          opacity={isLoading ? 0.5 : 1}
        >
          {t('RESERVE')}
        </Button>
      </div>
    </div>
  );
};

export default ConfirmacionExterno;
